// Imports


// Stateful components

export class ErrorHandler extends React.Component{

    // Lifecycle

    constructor(props) {
        super(props);

        this.state = {
            'has_error': false,
            'error_name': '',
            'error_message': ''
        };
    }

    // Update state so the next render will show the fallback UI.
    static getDerivedStateFromError(error) {
        return { 
            'has_error': true,
            'error_name': error['name'],
            'error_message': error['message']
        };
    }


    // Render

    render() {
        var this_component = this;

        if (this_component['state']['has_error']) {
            var error_name = this_component['state']['error_name'];
            var error_message = this_component['state']['error_message'];

            return (
                <div className="error-handler">
                    <span><strong>{error_name}: </strong> {error_message}</span>
                </div>
            );
        }

        return this_component.props.children; 
    }
}
